// import hash from 'object-hash';
// import { ObjectHash } from './object-hash';

export const generateOsmosysObjectHash = (obj: any, options?: any): string => {
  return JSON.stringify({ obj, options });
};
